const lllconfig = {
  subjects: [
    {
      name: 'Archaeology, Classics and Egyptology',
      id: '158',
      image: '/2t4/js/apps/shortcourses/img/archaeology.jpg',
    },
    {
      name: 'Art and Art History',
      id: '163',
      image: '/2t4/js/apps/shortcourses/img/art.jpg',
    },
    /* {name: "Business Development", id:"169", image:"/media/media_434994_en.jpg"},*/
    {
      name: 'Creative Writing',
      id: '159',
      image: '/2t4/js/apps/shortcourses/img/writing.jpg',
    },
    {
      name: 'History, International Affairs and Politics',
      id: '168',
      image: '/2t4/js/apps/shortcourses/img/politics.jpg',
    },
    {
      name: 'Languages',
      id: '162',
      image: '/2t4/js/apps/shortcourses/img/languages.jpg',
    },
    {
      name: 'Languages - Taster',
      id: '235',
      image: '/2t4/js/apps/shortcourses/img/languages.jpg',
    },
    {
      name: 'Literature and Film',
      id: '164',
      image: '/2t4/js/apps/shortcourses/img/literature.jpg',
    },
    /* {name: "Music", id:"165", image:"/2t4/js/apps/shortcourses/img/music.jpg"},*/
    {
      name: 'Philosophy',
      id: '160',
      image: '/2t4/js/apps/shortcourses/img/philosophy.jpg',
    },
    {
      name: 'Practical Art',
      id: '234',
      image: '/2t4/js/apps/shortcourses/img/practical-art.jpg',
    },
    {
      name: 'Psychology and Counselling',
      id: '161',
      image: '/2t4/js/apps/shortcourses/img/psychology.jpg',
    },
    {
      name: 'Science',
      id: '167',
      image: '/2t4/js/apps/shortcourses/img/science.jpg',
    },

    /* {name: "Online courses", id:"171", image:"/2t4/js/apps/shortcourses/img/Online-courses.jpg"},*/
  ],
  delivery_method: [
    // {name: "Course for credits", id:"173", image:"/2t4/js/apps/shortcourses/img/courses-for-credit.jpg"},
    {
      name: 'Courses on campus',
      id: '231',
      image: '/2t4/js/apps/shortcourses/img/courses-on-campus.jpg',
    },
    {
      name: 'Courses online',
      id: '171',
      image: '/2t4/js/apps/shortcourses/img/courses-on-campus.jpg',
    },
    {
      name: 'Courses on location',
      id: '233',
      image: '/2t4/js/apps/shortcourses/img/courses-on-campus.jpg',
    },
  ],
};
export default lllconfig;
